module.exports = __webpack_public_path__ + "static/french_circle_3-9c36aa4821a0e05d9203a877a18a9a98.svg";